import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  FormText,
  Input,
  Table,
  Label,
  Row,
  Col
} from "reactstrap";

import Image from "react-image";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button, Statistics } from "components";

import { theadwebmobilerequests, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";
import moment from "moment";
import "moment/locale/es";

var dashboardOrdersTitleStyle = {
  margin: "0 0 20px 20px",
  color: "#FFF"
};
//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

class WebContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      servicesSize: "auto",
      shownNotifications: [],
      webformDetailsId: "",
      collapse: {
        "Atendidos": true,
        "Atendidos (Todos)": true,
        "En proceso (Todos)": true
      }
    };
    this.redirectTo = this.redirectTo.bind(this);
    this.buildContent = this.buildContent.bind(this);
    this.buildWebforms = this.buildWebforms.bind(this);
    this.createWebformsTable = this.createWebformsTable.bind(this);
    this.buildWebformDetailsInTable = this.buildWebformDetailsInTable.bind(this);
    this.toggleCollapseForms = this.toggleCollapseForms.bind(this);
    this.isCollapsed = this.isCollapsed.bind(this);
  }
  componentDidMount() {
    // console.log("webContent props", this.props);
    this.props.getWebContent("free_webforms");
    this.props.getWebContent("my_webforms");
    this.props.getWebContent("my_attended_webforms");
    // if (parseInt(this.props.mainState.user.uid) === 469) {
      this.props.getWebContent("all_assigned_webforms");
      this.props.getWebContent("all_attended_webforms");
    // }
  }
  componentDidUpdate() {
    // console.log("webContent props", this.props);
    // console.log("webContent mainState", this.props.mainState);
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  toggleCollapseForms(title) {
    let collapse = this.state.collapse;
    if (!(title in collapse)) {
      collapse[title] = true;
    } else {
      collapse[title] = !collapse[title];
    }
    this.setState({ collapse: collapse });
  }
  isCollapsed(title) {
    let collapse = this.state.collapse;
    if (title in collapse) {
      collapse = collapse[title];
    } else {
      collapse = false;
    }
    return collapse;
  }
  createWebformsTable(webforms, special) {
    special = true;
    if (!webforms) return null;
    if (webforms && Object.keys(webforms).length === 0) return null;
    let result = null;
    let ids = Object.keys(webforms);
    ids = ids.sort();

    let tbody = (
      <tbody>
        {ids.map(currentId => {
          let webform = webforms[currentId];
          let isBeingAssinged = this.props.mainState.isAssigningWebform[webform.id];
          let isBeingClosed = this.props.mainState.isClosingWebform[webform.id];
          let closeWebformButton = null;
          if (webform.state.id === 356) {
            closeWebformButton = (
              <Button
                onClick={() => {
                  this.props.closeWebform(webform.id);
                  // alert("Vas a gestionar este formulario");
                }}
                color={"primary"}
                // size="sm"
                round
                icon
                disabled={isBeingClosed}
              >
                <i className={isBeingClosed ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "fa fa-check"} />
              </Button>
            );
          }
          let assignButton = null;
          if (webform.state.id !== 357) {
            assignButton = (
              <Button
                  onClick={() => {
                    this.props.assignWebform(webform.id, webform.state.id !== 355);
                    // alert("Vas a gestionar este formulario");
                  }}
                  color={webform.state.id === 355 ? "primary" : "danger"}
                  // size="sm"
                  round
                  icon
                  disabled={isBeingAssinged}
                >
                  <i className={isBeingAssinged ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : (webform.state.id === 355 ? "fa fa-user-plus" : "fa fa-user-times")} />
              </Button>
            );
          }
          let agentName = "";
          if (webform && webform.agent) {
            agentName = webform.agent.username;
          }
          let detailsButton = (
            <Button
              onClick={() => {
                this.redirectTo("/web/detalles/" + webform.id);
                // alert("Vas a gestionar este formulario");
              }}
              color={"info"}
              // size="sm"
              round
              icon
              // disabled={isBeingClosed}
            >
              <i className={"now-ui-icons ui-1_zoom-bold"} />
            </Button>
          );
          let webformRow = (
            <tr 
              key={webform.id} 
              className={webform.id === this.state.webformDetailsId ? "detalle-webform" : ""}
            >
              <td>{moment(webform.date).fromNow()}</td>
              <td>{webform.name}</td>
              {special && <td>{agentName}</td>}
              <td className="text-right">
                <Button
                  onClick={() => {
                    let newWebformDetailsId = webform.id;
                    if (this.state.webformDetailsId === webform.id) {
                      newWebformDetailsId = "";
                    }
                    this.setState({ webformDetailsId: newWebformDetailsId });
                  }}
                  color="default"
                  // size="sm"
                  round
                  icon
                >
                  {/* <i className="now-ui-icons files_paper" /> */}
                  <i className={"fa fa-" + (this.state.webformDetailsId === webform.id ? "times": "align-left")} />
                </Button>{" "}
                {detailsButton}{" "}
                {assignButton}{" "}
                {closeWebformButton}
              </td>
            </tr>
          );
          let detail = this.buildWebformDetailsInTable(webform);
          if (detail) webformRow = [webformRow, detail];
          return webformRow;
        })}
      </tbody>
    );

    result = (
      <Table responsive striped style={{ overflow: "hidden" }}>
        <thead className="text-primary">
          <tr>
            <th>Fecha</th>
            <th>Formulario</th>
            {special && <th>Agente</th>}
            <th className="text-right">Acciones</th>
          </tr>
        </thead>
        {tbody}
      </Table>
    );

    return result;
  }
  buildWebformDetailsInTable(webform) {
    if (!webform) return null;
    if (webform.id !== this.state.webformDetailsId) return null;
    let result = null;
    
    result = (
      <tr 
        key={webform.id + "-detail"} 
        className={webform.id === this.state.webformDetailsId ? "detalle-webform" : ""}
      >
        <td colSpan="3">
          <Row>
            <Col xs={12}>
              {webform.fields.map( field => {
                let renderedField;

                renderedField = (
                  <Row>
                    <Col xs={12}>
                      <b>{field.name}</b>
                    </Col>
                    {field.value.map((value, key) => {
                      return (
                        <Col key={field.name + "-" + key}>
                          <FormGroup>
                            <Input
                              disabled
                              type="text"
                              placeholder="1234578A"
                              value={value}
                              // onChange={event => {
                              //   let newValue = event.target.value;
                              //   this.setState({ nif: newValue });
                              //   this.validateField("nif", newValue);
                              // }}
                            />
                          </FormGroup>
                        </Col>
                      );
                    })}
                  </Row>
                );

                return renderedField;
              })}
            </Col>
          </Row>
        </td>
      </tr>
    );
    return result;
  }

  // El parámetro "special" es para cuando vamos a cargar datos de admin
  buildWebforms(state, title, special) {
    let result = null;
    let isCollapsed = this.isCollapsed(title);
    let webforms = this.props.mainState.webforms;
    if (webforms && special) webforms = this.props.mainState.adminWebforms;
    if (!webforms) return null;
    let ids = [];
    if (webforms) ids = Object.keys(webforms);
    if (!(!ids || ids.length === 0)) {
      let filtered_webforms = [];
      ids.map(id => {
        let webform = webforms[id];
        // console.log("Filtrando webforms: ", webform);
        if (webform.state.id === state) filtered_webforms[id] = webform;
      });
      webforms = filtered_webforms;
      if (webforms) ids = Object.keys(webforms);
    }
    let contentTable = null;
    if (!ids || ids.length === 0) {
      if (this.props.mainState.isGettingwebContent) {
        contentTable = (
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
        );
      } else {
        contentTable = (
          <div>No hay formularios.</div>
        );
      }
    } else {
      contentTable = isCollapsed ? null : this.createWebformsTable(webforms, special, this.isCollapsed(title));
    }
    // console.log("webforms state (" + state + "): ", webforms);

    let collapseButton = (
      <Button
        onClick={() => {
          this.toggleCollapseForms(title);
          // alert("Vas a gestionar este formulario");
        }}
        color="default"
        size="sm"
        // round
        // icon
        // disabled={isBeingClosed}
      >
        {isCollapsed
          ? "Mostrar todos (" + Object.keys(webforms).length + ")"
          : "Ocultar"}
      </Button>
    );

    result = (
      <Card>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardBody>
          {collapseButton}
          {contentTable}
        </CardBody>
      </Card>
    );

    return result;
  }
  // Estados de los webforms:
  //  -Sin leer (355)
  //  -Gestionando (356)
  //  -Atendido (357)
  buildContent() {
    let content = null;
    content = (
      <Row>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12}>
              {this.buildWebforms(355, "Esperando")}
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12}>
              {this.buildWebforms(356, "En proceso")}
              {this.buildWebforms(357, "Atendidos")}
            </Col>
          </Row>
        </Col>
        {this.props.mainState.user.uid === "469" && 
          <Col xs={12}>
            <Row>
              <Col xs={12} md={6}>
                {this.buildWebforms(356, "En proceso (Todos)", true)}
              </Col>
              <Col xs={12} md={6}>
                {this.buildWebforms(357, "Atendidos (Todos)", true)}
              </Col>
            </Row>
          </Col>
        }
      </Row>
    );
    return content;
  }
  render() {
    let contentToDisplay = this.buildContent();
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <span>Formularios web</span>
          // }
        />
        <div className="content">{contentToDisplay}</div>
      </div>
    );
  }
}

export default WebContent;



// WEBPACK FOOTER //
// ./src/views/Web/WebContent.jsx